import React from "react";
import styles from "./initials-avatar.module.scss";

interface InitialsAvatarProps {
	name: string;
	index: number;
	size?: number;
	fontSize?: number;
}

// Filled circle showing the uppercased initials of `name`, colored from a
// fixed palette cycled by `index`. Colors are the shared --app-avatar-* tokens
// defined in _variables.scss.
const PALETTE = ["var(--app-avatar-1)", "var(--app-avatar-2)", "var(--app-avatar-3)"];

export const initialsOf = (name: string): string => {
	const parts = name.trim().split(/\s+/);
	if (parts.length >= 2 && parts[0] && parts[1]) {
		return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
	}
	return name ? name[0].toUpperCase() : "";
};

const InitialsAvatar: React.FC<InitialsAvatarProps> = ({ name, index, size = 36, fontSize = 13 }) => {
	return (
		<span
			className={styles.avatar}
			style={{
				width: size,
				height: size,
				fontSize,
				backgroundColor: PALETTE[index % PALETTE.length],
			}}
			aria-hidden="true"
		>
			{initialsOf(name)}
		</span>
	);
};

export default InitialsAvatar;
